import type { PaginationType } from './components/ProductTable';

export const tabs = ['Todos', 'Aprovados', 'Em Análise', 'Reprovados', 'Inativos'];

export enum TabsIndexes {
  ALL = 0,
  APPROVED = 1,
  PENDING = 2,
  REPROVED = 3,
  INACTIVE = 4,
  COPRODUCTIONS = 5,
  IRREGULAR = 6
}

export type TableType = {
  products: any;
  order: any;
  onSort: any;
  onClickOptions: any;
  isLoading: boolean;
  pagination: PaginationType;
};

export type IrregularProduct = {
  id: number;
  parent_product?: number;
  title: string;
  image: string;
  image_id: number;
  status: 'active' | 'inactive' | 'filed' | ' ';
  active: number;
  producer_id: number;
  has_children: boolean;
  pending_actions: {
    above_coproducers_limit: boolean;
    above_commission_limit: boolean;
    commission_by_value: boolean;
    invalid_physical_dimensions: boolean;
  } | null;
};
